import { SnoozeTwoTone } from "@mui/icons-material";
import { ActionState, PlayerAction, Position, PressedKeys, NextPosition, Player, Block, Distance } from "./Types";

const getRandom = (min: number, max: number) => {
    return Math.random() * (max - min) + min;
}

const normalizeCoordinate = (
    coordinate: number,
    blockSnapSize: number
): number => {
    return Math.round((coordinate - blockSnapSize) / blockSnapSize);
}

const getBlockDistance = (
    player: [number, number],
    block: [number, number],
    blockSnapSize: number
): [number, number] => {
    const x = normalizeCoordinate(player[0] - block[0], blockSnapSize) + 1;
    const y = normalizeCoordinate(player[1] - block[1], blockSnapSize) + 1;

    return [x, y]
}


const keysToPlayerActions = (keys: PressedKeys): PlayerAction => {
    const actionsKeys: PlayerAction = [0, 0];

    if (!keys) {
        return actionsKeys;
    }

    if (keys[0]) {
        actionsKeys[0] = keys[0] == "ArrowRight" ? 1 : -1;
    }
    if (keys[1]) {
        actionsKeys[1] = keys[1] == "ArrowUp" ? -1 : 1;
    }

    return actionsKeys;
}


const isPositionsEqaul = (
    position1: Position | null | undefined,
    position2: Position | null | undefined
) => {
    if (!position1 && !position2) {
        return false;
    }
    if (!position1) {
        return false;
    }
    if (!position2) {
        return false;
    }

    return position1[0] === position2[0] && position1[1] === position2[1];
}


const getNextMove = (
    playerPosition: Position,
    nextPositions: Position[] | undefined,
    shift: number
): NextPosition => {
    if (!nextPositions || nextPositions.length == 0) {
        return [undefined, undefined];
    }

    const np = nextPositions[0];

    const newPosition: Position = [playerPosition[0], playerPosition[1]];
    const pressedKeys: PressedKeys = [null, null];

    if (playerPosition[0] > np[0]) {
        newPosition[0] = newPosition[0] - shift;
        pressedKeys[0] = "ArrowLeft";
    } else if (playerPosition[0] < np[0]) {
        newPosition[0] = newPosition[0] + shift;
        pressedKeys[0] = "ArrowRight";
    }

    if (playerPosition[1] > np[1]) {
        newPosition[1] = newPosition[1] - shift;
        pressedKeys[1] = "ArrowUp";
    } else if (playerPosition[1] < np[1]) {
        newPosition[1] = newPosition[1] + shift;
        pressedKeys[1] = "ArrowDown";
    }

    return [newPosition, pressedKeys];
}


const exportToJson = (actions: ActionState[]): void => {
    const blob = new Blob([JSON.stringify(actions, null, 2)], { type: 'application/json' });

    saveFile(blob);
}

const saveFile = async (blob: any) => {
    const a = document.createElement('a');
    a.download = 'data.json';
    a.href = URL.createObjectURL(blob);
    a.addEventListener('click', (e) => {
        setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
    });
    a.click();
};

const isHit = (
    player: Player,
    block: Block,
    blockWidth: number,
    blockSnapSize: number,
    isByItself: boolean) => {
    if (!isByItself) {
        if (player.position[1] == block.position[1]) {
            if (player.position[0] >= (block.position[0])
                && player.position[0] < (block.position[0] + blockWidth)) {
                return true
            }
        }
        return false;
    }
    const yHit = player.position[1] >= block.position[1] - blockSnapSize
        && player.position[1] <= block.position[1] + blockSnapSize;
    if (yHit) {
        const extendBy = blockSnapSize * 3;
        const xHit = player.position[0] >= block.position[0] - extendBy
            && player.position[0] < (block.position[0] + blockWidth + extendBy)

        return xHit;
    }
    return false;
};

const calculateTargetLen = (distance: Distance, blockSnapSize: number) => {
    const diagonalDistance = Math.sqrt(distance[0] * distance[0] + distance[1] * distance[1]) / 3;

    if (diagonalDistance < 4) {
        return 4;
    }

    return Math.round(diagonalDistance);
};

export {
    getRandom,
    normalizeCoordinate,
    getBlockDistance,
    keysToPlayerActions,
    exportToJson,
    getNextMove,
    isPositionsEqaul,
    isHit,
    calculateTargetLen,
};
